import React from "react";
import {Outlet} from "react-router-dom";
import DashboardHeader from "./components/dashboard/header";
import DashboardFooter from "./components/dashboard/footer";
import DashboardSidebar from "./components/dashboard/sidebar";

export default function Dashboard() {
    return (
        <div className="w-screen h-screen overflow-hidden flex flex-col">
            <DashboardHeader/>
            <div className="flex-1 flex flex-grow h-full">
                <DashboardSidebar/>
                <main className="dashboard-content">
                    <Outlet/>
                    <DashboardFooter/>
                </main>
            </div>
        </div>
    );
}